<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, computed } from 'vue';
import UtilDateTime from '@/utils/UtilDateTime.js';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
        default: 'dd/mm/aaaa'
    },
});

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits([
    'change',
]);

/*==================================================================*/
/*================== COMPUTED VALUE ISO ============================*/
/*==================================================================*/

const valueISO = computed(() => {

    return UtilDateTime.toFormatISO({ dateTime: props.value });

});

/*==================================================================*/
/*================== MÉTODOS =======================================*/
/*==================================================================*/

const onChange = (event = "") => {

    let valueUTC = UtilDateTime.toFormatUTC({ dateTime: event || "" });

    if(!valueUTC){
        valueUTC = "";
    }

    emits('change', valueUTC);

}

</script>

<template>

    <v-text-field
        class="c-text-field"
        type="date"
        :label="props.label"
        :value="valueISO"
        :disabled="props.disabled"
        :placeholder="props.placeholder"
        prepend-icon="mdi-calendar"
        outlined
        hide-details
        @change="onChange($event)"
    ></v-text-field>

</template>

<style scoped>

.c-text-field{
    padding: 2px;
}

.c-text-field >>> .v-input__slot{
    min-height: 48px;
}

</style>